@if (currentData; as currentData) {
  @if (isExcelloTheme) {
    <energymonitor-flow [currentData]="currentData"></energymonitor-flow>
  } @else {
    <energymonitor-chart [currentData]="currentData"></energymonitor-chart>
  }
}
